module.exports = __webpack_public_path__ + "static/media/9.e0ab27dc.jpg";